// Types
import { Order } from "@/types/supabase";
// Utils
import { translatePaidWith } from "@/lib/utils";
// Components
import StatusBadge from "@/components/orders/StatusBadge";

interface PaymentDetailsProps {
  order: Order;
}

export default function PaymentDetails({ order }: PaymentDetailsProps) {
  return (
    <article className="py-4 px-3 sm:px-5 rounded-2xl space-y-4 border border-gray-200 flex-1">
      <header className="font-semibold text-black flex flex-wrap items-center gap-2">
        Detalles del pago{" "}
      </header>
      <section className="text-sm flex flex-col gap-2">
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Candado de facturación</span>
          <span>
            {order.invoice_lock && !order.is_paid ? (
              <StatusBadge status={"locked"} type="order" />
            ) : (
              <StatusBadge status={"unlocked"} type="order" />
            )}
          </span>
        </div>
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Estado de pago</span>
          <span>
            {order.is_paid ? (
              <StatusBadge status={"paid"} type="order" />
            ) : (
              <StatusBadge status={"pending"} type="order" />
            )}
          </span>
        </div>
        <div className="border-b border-gray-200" />
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Medio de pago</span>
          <span>{translatePaidWith(order.paid_with)}</span>
        </div>
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Subtotal</span>
          <span>${(order.subtotal ?? 0).toFixed(2)}</span>
        </div>
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Tax</span>
          <span>${(order.tax ?? 0).toFixed(2)}</span>
        </div>
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Envio</span>
          <span>${(order.total_delivery_charge ?? 0).toFixed(2)}</span>
        </div>
        <div className="flex flex-col xs:flex-row xs:justify-between xs:items-center gap-1 xs:gap-0">
          <span>Descuento</span>
          <span className="text-green-500">
            -${(order.discount ?? 0).toFixed(2)}
          </span>
        </div>
        <div className="flex flex-col xs:flex-row xs:justify-between font-semibold border-t pt-3 mt-2 gap-1 xs:gap-0">
          <span>Total</span>
          <span>
            $
            {(
              (order.subtotal ?? 0) +
              (order.tax ?? 0) +
              (order.total_delivery_charge ?? 0) -
              (order.discount ?? 0)
            ).toFixed(2)}
          </span>
        </div>
      </section>
    </article>
  );
}
